module.exports = __webpack_public_path__ + "img/2-1.e8a33066.png";